export default __webpack_public_path__ + "static/feature-user-sessions-c7e3f89f9a1de9f9bf9de79be8c9e9bd.png";